// Intentionally global
___export = require('./../../lib/src-server/azure-server').setDirName(__dirname).serve(require('./../../lib/src-server/example-function-async-await').main);
module.exports = ___export;


//////////////////
// WEBPACK FOOTER
// ./deployment/example-function-async-await/build.source.js
// module id = 274
// module chunks = 14